import {
  COOKIES_PAGE_SLUG,
  COURSE_BUILDER_CONTENTFUL_SLUG,
  OLD_PRIVACY_PAGE_CONTENTFUL_SLUG,
  OLD_TERMS_PAGE_CONTENTFUL_SLUG,
  PRIVACY_CCPA_PAGE_CONTENTFUL_SLUG,
  PRIVACY_DPA_PAGE_CONTENTFUL_SLUG,
  PRIVACY_PAGE_CONTENTFUL_SLUG,
  SECURITY_PAGE_SLUG,
  TERMS_PAGE_CONTENTFUL_SLUG,
  ZAPP_PAGE_CONTENTFUL_SLUG,
} from 'bundles/about/AboutConstants';

import _t from 'i18n!nls/about';

export const getAboutPageContentfulSlug = (pathname: string) => {
  switch (pathname) {
    case '/about/terms':
      return TERMS_PAGE_CONTENTFUL_SLUG;
    case '/about/terms-old':
      return OLD_TERMS_PAGE_CONTENTFUL_SLUG;
    case '/about/live2coursera-terms':
      return ZAPP_PAGE_CONTENTFUL_SLUG;
    case '/about/privacy':
      return PRIVACY_PAGE_CONTENTFUL_SLUG;
    case '/about/privacy-old':
      return OLD_PRIVACY_PAGE_CONTENTFUL_SLUG;
    case '/about/privacy/ccpa':
      return PRIVACY_CCPA_PAGE_CONTENTFUL_SLUG;
    case '/about/privacy/data-protection-addendum':
      return PRIVACY_DPA_PAGE_CONTENTFUL_SLUG;
    case '/about/cookies':
      return COOKIES_PAGE_SLUG;
    case '/about/security':
      return SECURITY_PAGE_SLUG;
    case '/about/terms-enterprise-content-authoring-addendum':
      return COURSE_BUILDER_CONTENTFUL_SLUG;
    default:
      return '';
  }
};

export const getAboutPageMetatags = (pathname: string) => {
  switch (pathname) {
    case '/about/terms':
    case '/about/terms-old':
    case '/about/live2coursera-terms':
      return {
        title: _t('Terms of Use'),
        description: _t(
          'Please read these Terms carefully, and contact us if you have any questions. By using our Services, you agree to be bound by these Terms, including the policies referenced in these Terms'
        ),
      };
    case '/about/privacy':
    case '/about/privacy-old':
      return {
        title: _t('Privacy Notice'),
        description: _t(
          'You can find information about us and how we collect, use and store your personal data in each section of this privacy notice.'
        ),
      };
    case '/about/privacy/ccpa':
      return {
        title: _t('Privacy CCPA'),
        description: _t(
          'You can find information about us and how we collect, use and store your personal data in each section of this privacy notice.'
        ),
      };
    case '/about/privacy/data-protection-addendum':
      return {
        title: _t('Privacy DPA'),
        description: _t('Data Protection Agreement for your organization’s use of Coursera.'),
      };
    case '/about/cookies':
      return {
        title: _t('Cookies Policy'),
        description: _t(
          'Please read this Cookies Policy in conjunction with our Privacy Policy, which sets out additional details on how we use personally identifiable information and your various rights.'
        ),
      };
    case '/about/security':
      return {
        title: _t('Security at Coursera'),
        description: _t('You can find information about security at Coursera on this page'),
      };
    case '/about/terms-enterprise-content-authoring-addendum':
      return {
        title: _t('Content Authoring Addendum'),
        description: _t('Here you can find the terms governing the use of Coursera Content Authoring Tools.'),
      };
    default:
      return {};
  }
};

export default {
  getAboutPageContentfulSlug,
  getAboutPageMetatags,
};
